var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _radialGradient2, _linearGradient21, _linearGradient22, _radialGradient3, _linearGradient23, _radialGradient4, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _radialGradient5, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _radialGradient6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 362.1105493198,
    cy: 329.025898241,
    gradientUnits: "userSpaceOnUse",
    r: 180.0779063968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2085,
    stopColor: "#ff6a3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ff5f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    stopColor: "#ff4d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7501,
    stopColor: "#ff3361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9195,
    stopColor: "#ff1278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0084"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0084",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    stopColor: "#f4087e",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    stopColor: "#d2216b",
    stopOpacity: 0.333333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#ba335e",
    stopOpacity: 0.584314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#ab3d56",
    stopOpacity: 0.811765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 505.7549216302,
    x2: 409.1565428682,
    xlinkHref: "#b",
    y1: 467.2942682414,
    y2: 370.6958894794
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 444.5016247222,
    x2: 415.0798834526,
    xlinkHref: "#b",
    y1: 530.260055297,
    y2: 467.7385037264
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 402.3420207244,
    x2: 402.3420207244,
    xlinkHref: "#e",
    y1: 344.271959694,
    y2: 418.0840196454
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 402.3420207244,
    x2: 402.3420207244,
    xlinkHref: "#e",
    y1: 433.0550064704,
    y2: 496.1460829916
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#bfdcfd",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 436.0139661732,
    x2: 387.9302184534,
    xlinkHref: "#h",
    y1: 459.2373926226,
    y2: 442.1753366638
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8567,
    stopColor: "#0b9cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d94fe"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 392.1579347798,
    x2: 412.5259058846,
    xlinkHref: "#j",
    y1: 453.3317210654,
    y2: 453.3317210654
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d94fe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5142,
    stopColor: "#0681cd",
    stopOpacity: 0.513725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070a2"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 411.9783668258,
    x2: 394.3112470776,
    xlinkHref: "#l",
    y1: 437.5691417434,
    y2: 419.9020219952
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 390.6011529344,
    x2: 414.0798767484,
    xlinkHref: "#j",
    y1: 420.9201996876,
    y2: 420.9201996876
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 292.6837210566,
    x2: 512.00022,
    xlinkHref: "#j",
    y1: 109.6582996678,
    y2: 109.6582996678
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 505.7549216302,
    x2: 409.1565428682,
    xlinkHref: "#l",
    y1: 174.6117518912,
    y2: 78.0133731292
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 444.5016247222,
    x2: 415.0798834526,
    xlinkHref: "#l",
    y1: 237.5775389468,
    y2: 175.0559873762
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 402.3420207244,
    x2: 402.3420207244,
    xlinkHref: "#e",
    y1: 51.5894433438,
    y2: 125.401402903
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 402.3420207244,
    x2: 402.3420207244,
    xlinkHref: "#e",
    y1: 140.3724901202,
    y2: 203.4635666414
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 436.0139661732,
    x2: 387.9302184534,
    xlinkHref: "#h",
    y1: 166.5548762724,
    y2: 149.4928203136
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2296,
    stopColor: "#ffd355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4362,
    stopColor: "#ffcf4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#ffc838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb400"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 402.3419203322,
    cy: 160.6492047152,
    gradientUnits: "userSpaceOnUse",
    r: 20.0822549036,
    xlinkHref: "#u"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0396,
    stopColor: "#e27f04",
    stopOpacity: 0.039216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#c15d2f",
    stopOpacity: 0.466667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#ad4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 411.9783668258,
    x2: 394.3112470776,
    xlinkHref: "#w",
    y1: 144.8866253932,
    y2: 127.219505645
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 402.3405148414,
    cy: 128.2375829452,
    gradientUnits: "userSpaceOnUse",
    r: 9.8375320702,
    xlinkHref: "#u"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8be1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1873,
    stopColor: "#87e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3558,
    stopColor: "#7ce2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5172,
    stopColor: "#6ae2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6741,
    stopColor: "#50e4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8278,
    stopColor: "#2fe5c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9772,
    stopColor: "#07e7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e7b2"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 69.4268282632,
    cy: 329.0259986332,
    gradientUnits: "userSpaceOnUse",
    r: 180.0779063968,
    xlinkHref: "#z"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#00e7b2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4308,
    stopColor: "#1bc4b7",
    stopOpacity: 0.427451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b9abe"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 213.0711001814,
    x2: 116.4728218116,
    xlinkHref: "#B",
    y1: 467.2942682414,
    y2: 370.6958894794
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 151.8179036656,
    x2: 122.3960620038,
    xlinkHref: "#B",
    y1: 530.260055297,
    y2: 467.7386041186
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 109.6581992756,
    x2: 109.6581992756,
    xlinkHref: "#e",
    y1: 344.2720600862,
    y2: 418.0839192532
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 109.6582996678,
    x2: 109.6582996678,
    xlinkHref: "#e",
    y1: 433.0551068626,
    y2: 496.1459825994
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 143.3302451166,
    x2: 95.2464973968,
    xlinkHref: "#h",
    y1: 459.2373926226,
    y2: 442.1753366638
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1596,
    stopColor: "#ff6440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    stopColor: "#ff4b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7662,
    stopColor: "#ff216e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0084"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 99.4742137232,
    x2: 119.842184828,
    xlinkHref: "#H",
    y1: 453.3318214576,
    y2: 453.3318214576
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 121.4698435666,
    x2: 103.8027238184,
    y1: 439.7443395408,
    y2: 422.0772197926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4003d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5838,
    stopColor: "#bd294b",
    stopOpacity: 0.584314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 97.9174318778,
    x2: 121.3961556918,
    xlinkHref: "#H",
    y1: 420.9200992954,
    y2: 420.9200992954
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "L",
    cx: 69.4268282632,
    cy: 36.3433818908,
    gradientUnits: "userSpaceOnUse",
    r: 180.0779063968,
    xlinkHref: "#u"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 174.587557371,
    x2: 77.989178609,
    xlinkHref: "#w",
    y1: 136.1280082964,
    y2: 39.5296295344
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 136.9079552982,
    x2: 107.4861136364,
    xlinkHref: "#w",
    y1: 205.8937606268,
    y2: 143.3722090562
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 109.6582996678,
    x2: 109.6582996678,
    y1: 51.5894433438,
    y2: 125.401402903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 109.6582996678,
    x2: 109.6582996678,
    xlinkHref: "#e",
    y1: 140.3724901202,
    y2: 203.4635666414
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 143.3302451166,
    x2: 95.246597789,
    xlinkHref: "#h",
    y1: 166.5547758802,
    y2: 149.4928203136
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8be1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1426,
    stopColor: "#7fe2de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4015,
    stopColor: "#5fe3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    stopColor: "#2be5c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e7b2"
  }))), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 106.0390604656,
    x2: 117.683752528,
    xlinkHref: "#R",
    y1: 160.6492047152,
    y2: 160.6492047152
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 121.4698435666,
    x2: 103.8027238184,
    xlinkHref: "#B",
    y1: 147.0617227984,
    y2: 129.3947034424
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 107.8486298706,
    x2: 113.6075280314,
    xlinkHref: "#R",
    y1: 128.2375829452,
    y2: 128.2375829452
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 186.1194086006,
    x2: 319.1325481076,
    xlinkHref: "#e",
    y1: 187.1884851384,
    y2: 320.2016246454
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 398.254351517,
    x2: 197.3930510918,
    xlinkHref: "#h",
    y1: 279.172637604,
    y2: 279.172637604
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 197.9723140858,
    x2: 366.963106699,
    y1: 202.1771409906,
    y2: 371.1679336038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3251"
  }))), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3251",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientUnits: "userSpaceOnUse",
    x1: 323.3048479396,
    x2: 275.5501858514,
    xlinkHref: "#Y",
    y1: 329.772314248,
    y2: 282.017752552
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    gradientUnits: "userSpaceOnUse",
    x1: 248.599698977,
    x2: 292.7258857806,
    xlinkHref: "#z",
    y1: 255.0671652854,
    y2: 299.193352089
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    gradientUnits: "userSpaceOnUse",
    x1: 328.0787982262,
    x2: 134.8917787456,
    xlinkHref: "#Y",
    y1: 297.769790693,
    y2: 234.3352724556
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ac",
    cx: 278.7144476032,
    cy: 329.29143561,
    gradientUnits: "userSpaceOnUse",
    r: 281.4772409472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    stopColor: "#fff",
    stopOpacity: 0.858824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 402.339844c0 60.5625-49.097656 109.660156-109.660156 109.660156s-109.65625-49.097656-109.65625-109.660156 49.09375-109.65625 109.65625-109.65625 109.660156 49.09375 109.660156 109.65625zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m511.488281 412.914062c-2.140625 22.546876-11.128906 43.101563-24.847656 59.5625-5.417969 6.503907-11.574219 12.378907-18.347656 17.464844l-75.710938-75.710937-19.050781-19.046875c-8.4375-7.777344-13.730469-18.925782-13.730469-31.304688 0-23.492187 19.046875-42.539062 42.539063-42.539062 12.378906 0 23.527344 5.292968 31.304687 13.730468zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m486.636719 472.476562c-5.417969 6.503907-11.570313 12.378907-18.34375 17.464844-18.351563 13.859375-41.195313 22.058594-65.953125 22.058594-3.101563 0-6.171875-.125-9.210938-.394531l-50.429687-50.359375c5.375-24.238282 25.148437-43.046875 49.882812-47.015625 3.183594-.507813 6.441407-.777344 9.757813-.777344 16.878906 0 32.148437 6.847656 43.203125 17.898437zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m444.882812 363.882812c0 23.496094-19.046874 42.539063-42.542968 42.539063-23.492188 0-42.539063-19.042969-42.539063-42.539063 0-23.496093 19.046875-42.542968 42.539063-42.542968 23.496094 0 42.542968 19.046875 42.542968 42.542968zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m461.988281 461.25c-15.191406 15.394531-36.308593 24.929688-59.648437 24.929688-23.335938 0-44.453125-9.535157-59.640625-24.929688 6.066406-27.351562 30.460937-47.796875 59.640625-47.796875 16.878906 0 32.148437 6.847656 43.203125 17.898437 8.066406 8.058594 13.890625 18.367188 16.445312 29.898438zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m461.988281 461.25c-.238281.246094-.488281.484375-.734375.722656-14.363281 14.21875-33.855468 23.253906-55.449218 24.125l-10.785157-10.808594-.164062-.132812c-1.902344-1.574219-2.894531-3.980469-2.667969-6.441406l3.753906-39.027344c.070313-.683594.359375-1.292969.796875-1.777344-.042969-.050781-.074219-.105468-.113281-.167968-.613281-.390626-1.128906-.949219-1.4375-1.644532l-4.324219-9.574218c-.300781-.652344-.332031-1.34375-.15625-1.964844.546875-.101563 1.097657-.207032 1.65625-.289063.390625-.070312.792969-.132812 1.1875-.183593.3125-.050782.632813-.09375.953125-.136719.363282-.039063.722656-.09375 1.09375-.125.445313-.050781.890625-.09375 1.335938-.132813.433594-.042968.878906-.074218 1.324218-.105468.453126-.03125.910157-.050782 1.363282-.070313.902344-.042969 1.808594-.0625 2.71875-.0625 1.667968 0 3.320312.0625 4.957031.195313.433594.042968.867187.074218 1.292969.125.875.082031 1.757812.199218 2.625.320312.421875.0625.859375.136719 1.28125.207031.496094.074219.992187.167969 1.480468.269531 12.210938 2.347657 23.121094 8.335938 31.570313 16.78125 8.0625 8.058594 13.886719 18.367188 16.441406 29.898438zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m409.828125 475.160156-4.253906 3.519532c-1.875 1.550781-4.589844 1.550781-6.464844 0l-4.253906-3.519532c-1.902344-1.570312-2.902344-3.984375-2.664063-6.441406l3.753906-39.027344c.15625-1.628906 1.523438-2.871094 3.160157-2.871094h6.472656c1.636719 0 3.003906 1.242188 3.160156 2.871094l3.753907 39.027344c.234374 2.453125-.761719 4.871094-2.664063 6.441406zm0 0",
    fill: "url(#k)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m408.738281 429.691406c-.15625-1.628906-1.523437-2.871094-3.160156-2.871094h-6.472656c-.964844 0-1.828125.441407-2.414063 1.128907l13.140625 13.140625zm0 0",
    fill: "url(#m)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m413.820312 416.523438-4.324218 9.578124c-.628906 1.394532-2.015625 2.285157-3.554688 2.285157h-7.199218c-1.539063 0-2.925782-.890625-3.554688-2.285157l-4.324219-9.578124c-.300781-.648438-.332031-1.34375-.15625-1.964844 3.765625-.722656 7.652344-1.105469 11.632813-1.105469 3.980468 0 7.871094.382813 11.632812 1.117187.179688.621094.136719 1.304688-.152344 1.953126zm0 0",
    fill: "url(#n)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m512 109.660156c0 60.5625-49.097656 109.65625-109.660156 109.65625s-109.65625-49.09375-109.65625-109.65625 49.09375-109.660156 109.65625-109.660156 109.660156 49.097656 109.660156 109.660156zm0 0",
    fill: "url(#o)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m511.488281 120.234375c-2.140625 22.542969-11.128906 43.097656-24.847656 59.5625-5.417969 6.503906-11.574219 12.375-18.347656 17.464844l-75.710938-75.714844-19.050781-19.046875c-8.4375-7.777344-13.730469-18.921875-13.730469-31.300781 0-23.496094 19.046875-42.542969 42.539063-42.542969 12.378906 0 23.527344 5.292969 31.304687 13.734375zm0 0",
    fill: "url(#p)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m486.636719 179.796875c-5.417969 6.503906-11.570313 12.375-18.34375 17.464844-18.355469 13.855469-41.195313 22.054687-65.953125 22.054687-3.101563 0-6.171875-.125-9.210938-.394531l-50.433594-50.355469c5.378907-24.242187 25.148438-43.050781 49.882813-47.019531 3.1875-.507813 6.445313-.777344 9.761719-.777344 16.875 0 32.148437 6.847657 43.203125 17.898438zm0 0",
    fill: "url(#q)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m444.882812 71.199219c0 23.496093-19.046874 42.542969-42.542968 42.542969-23.492188 0-42.539063-19.046876-42.539063-42.542969 0-23.492188 19.046875-42.539063 42.539063-42.539063 23.496094 0 42.542968 19.046875 42.542968 42.539063zm0 0",
    fill: "url(#r)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m461.988281 168.566406c-15.191406 15.394532-36.308593 24.929688-59.648437 24.929688-23.335938 0-44.453125-9.535156-59.640625-24.929688 6.066406-27.351562 30.460937-47.792968 59.640625-47.792968 16.878906 0 32.148437 6.84375 43.203125 17.898437 8.066406 8.054687 13.890625 18.363281 16.445312 29.894531zm0 0",
    fill: "url(#s)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m461.988281 168.566406c-.238281.246094-.488281.484375-.734375.722656-14.363281 14.21875-33.855468 23.257813-55.449218 24.125l-10.785157-10.808593-.164062-.132813c-1.902344-1.570312-2.894531-3.980468-2.667969-6.441406l3.753906-39.027344c.070313-.679687.359375-1.289062.796875-1.777344-.042969-.050781-.074219-.105468-.113281-.164062-.613281-.394531-1.128906-.953125-1.4375-1.644531l-4.324219-9.578125c-.300781-.652344-.332031-1.34375-.15625-1.964844.546875-.101562 1.097657-.207031 1.65625-.289062.390625-.070313.792969-.132813 1.1875-.183594.3125-.054688.632813-.09375.953125-.136719.363282-.039063.722656-.09375 1.09375-.121094.445313-.054687.890625-.09375 1.335938-.136719.433594-.039062.878906-.070312 1.324218-.101562.453126-.03125.910157-.054688 1.363282-.074219.902344-.039062 1.808594-.0625 2.71875-.0625 1.667968 0 3.320312.0625 4.957031.199219.433594.039062.867187.070312 1.292969.125.875.082031 1.757812.195312 2.625.320312.421875.058594.859375.132813 1.28125.203126.496094.074218.992187.167968 1.480468.269531 12.210938 2.347656 23.121094 8.335937 31.570313 16.785156 8.0625 8.054687 13.886719 18.363281 16.441406 29.894531zm0 0",
    fill: "url(#t)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m409.828125 182.476562-4.253906 3.519532c-1.875 1.550781-4.589844 1.550781-6.464844 0l-4.253906-3.519532c-1.902344-1.570312-2.902344-3.984374-2.664063-6.441406l3.753906-39.027344c.15625-1.628906 1.523438-2.871093 3.160157-2.871093h6.472656c1.636719 0 3.003906 1.242187 3.160156 2.871093l3.753907 39.027344c.234374 2.457032-.761719 4.871094-2.664063 6.441406zm0 0",
    fill: "url(#v)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m408.738281 137.007812c-.15625-1.628906-1.523437-2.871093-3.160156-2.871093h-6.472656c-.964844 0-1.828125.441406-2.414063 1.128906l13.140625 13.140625zm0 0",
    fill: "url(#x)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m413.820312 123.84375-4.324218 9.574219c-.628906 1.394531-2.015625 2.285156-3.554688 2.285156h-7.199218c-1.539063 0-2.925782-.890625-3.554688-2.285156l-4.324219-9.574219c-.300781-.652344-.332031-1.34375-.15625-1.964844 3.765625-.726562 7.652344-1.105468 11.632813-1.105468 3.980468 0 7.871094.378906 11.632812 1.113281.179688.621093.136719 1.304687-.152344 1.957031zm0 0",
    fill: "url(#y)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m219.316406 402.339844c0 60.5625-49.09375 109.660156-109.65625 109.660156s-109.660156-49.097656-109.660156-109.660156 49.097656-109.65625 109.660156-109.65625 109.65625 49.09375 109.65625 109.65625zm0 0",
    fill: "url(#A)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m218.800781 412.914062c-2.136719 22.542969-11.125 43.101563-24.847656 59.5625-5.417969 6.503907-11.570313 12.378907-18.34375 17.464844l-75.714844-75.710937-19.046875-19.046875c-8.4375-7.777344-13.730468-18.925782-13.730468-31.304688 0-23.492187 19.046874-42.539062 42.539062-42.539062 12.378906 0 23.527344 5.292968 31.300781 13.730468zm0 0",
    fill: "url(#C)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m193.953125 472.476562c-5.417969 6.503907-11.570313 12.378907-18.34375 17.464844-18.351563 13.859375-41.195313 22.058594-65.949219 22.058594-3.105468 0-6.175781-.125-9.214844-.394531l-50.429687-50.359375c5.375-24.238282 25.148437-43.046875 49.882813-47.015625 3.183593-.507813 6.441406-.777344 9.761718-.777344 16.875 0 32.148438 6.847656 43.199219 17.898437zm0 0",
    fill: "url(#D)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m152.199219 363.882812c0 23.496094-19.046875 42.539063-42.539063 42.539063-23.496094 0-42.542968-19.042969-42.542968-42.539063 0-23.496093 19.046874-42.542968 42.542968-42.542968 23.492188 0 42.539063 19.046875 42.539063 42.542968zm0 0",
    fill: "url(#E)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m169.300781 461.25c-15.1875 15.394531-36.304687 24.929688-59.644531 24.929688s-44.453125-9.535157-59.644531-24.929688c6.070312-27.351562 30.464843-47.796875 59.644531-47.796875 16.878906 0 32.148438 6.847656 43.203125 17.902344 8.066406 8.054687 13.890625 18.363281 16.441406 29.894531zm0 0",
    fill: "url(#F)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m169.300781 461.246094c-.238281.25-.484375.488281-.730469.726562-14.363281 14.21875-33.855468 23.253906-55.449218 24.125l-10.785156-10.808594-.164063-.132812c-1.902344-1.574219-2.894531-3.984375-2.667969-6.441406l3.753906-39.027344c.070313-.683594.359376-1.292969.792969-1.777344-.039062-.054687-.070312-.105468-.113281-.167968-.609375-.390626-1.125-.949219-1.4375-1.644532l-4.320312-9.574218c-.300782-.652344-.332032-1.34375-.15625-1.964844.546874-.105469 1.097656-.207032 1.65625-.289063.390624-.074219.792968-.136719 1.1875-.1875.3125-.050781.632812-.09375.953124-.132812.363282-.042969.722657-.09375 1.097657-.125.441406-.050781.886719-.09375 1.332031-.132813.433594-.042968.878906-.074218 1.324219-.105468.453125-.03125.910156-.050782 1.363281-.070313.902344-.042969 1.808594-.0625 2.722656-.0625 1.664063 0 3.316406.0625 4.953125.195313.433594.042968.867188.074218 1.292969.125.878906.082031 1.757812.195312 2.625.320312.421875.0625.859375.132812 1.28125.207031.496094.070313.992188.164063 1.480469.269531 12.210937 2.347657 23.121093 8.332032 31.570312 16.78125 8.0625 8.058594 13.886719 18.367188 16.4375 29.894532zm0 0",
    fill: "url(#G)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m117.144531 475.160156-4.253906 3.519532c-1.875 1.550781-4.589844 1.550781-6.464844 0l-4.253906-3.519532c-1.902344-1.570312-2.898437-3.984375-2.664063-6.441406l3.753907-39.027344c.15625-1.628906 1.523437-2.871094 3.160156-2.871094h6.472656c1.636719 0 3.003907 1.242188 3.160157 2.871094l3.753906 39.027344c.234375 2.453125-.761719 4.871094-2.664063 6.441406zm0 0",
    fill: "url(#I)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m116.054688 429.691406c-.15625-1.628906-1.523438-2.871094-3.160157-2.871094h-6.472656c-.964844 0-1.828125.4375-2.414063 1.128907l13.144532 13.140625zm0 0",
    fill: "url(#J)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m121.136719 416.523438-4.324219 9.578124c-.628906 1.394532-2.015625 2.285157-3.554688 2.285157h-7.199218c-1.539063 0-2.925782-.890625-3.554688-2.285157l-4.324218-9.578124c-.300782-.648438-.328126-1.34375-.152344-1.964844 3.761718-.722656 7.652344-1.105469 11.632812-1.105469 3.980469 0 7.867188.382813 11.632813 1.117187.175781.621094.132812 1.304688-.15625 1.953126zm0 0",
    fill: "url(#K)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m219.316406 109.660156c0 60.5625-49.09375 109.65625-109.65625 109.65625s-109.660156-49.09375-109.660156-109.65625 49.097656-109.660156 109.660156-109.660156 109.65625 49.097656 109.65625 109.660156zm0 0",
    fill: "url(#L)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m218.804688 120.234375c-2.140626 22.542969-11.128907 43.097656-24.847657 59.5625-5.417969 6.503906-11.574219 12.375-18.34375 17.464844l-94.761719-94.761719c-8.4375-7.777344-13.734374-18.921875-13.734374-31.300781 0-23.496094 19.046874-42.542969 42.542968-42.542969 12.375 0 23.523438 5.296875 31.300782 13.734375zm0 0",
    fill: "url(#M)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m193.953125 179.796875c-5.417969 6.503906-11.570313 12.375-18.34375 17.464844-18.351563 13.855469-41.195313 22.054687-65.949219 22.054687-3.105468 0-6.175781-.125-9.214844-.394531l-50.429687-50.355469c5.375-24.242187 25.148437-43.050781 49.882813-47.019531 3.183593-.507813 6.441406-.777344 9.761718-.777344 16.875 0 32.148438 6.847657 43.199219 17.898438zm0 0",
    fill: "url(#N)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m152.199219 71.199219c0 23.496093-19.046875 42.542969-42.539063 42.542969-23.496094 0-42.542968-19.046876-42.542968-42.542969 0-23.492188 19.046874-42.539063 42.542968-42.539063 23.492188 0 42.539063 19.046875 42.539063 42.539063zm0 0",
    fill: "url(#O)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m169.300781 168.566406c-15.1875 15.394532-36.304687 24.929688-59.644531 24.929688s-44.453125-9.535156-59.644531-24.929688c6.070312-27.351562 30.464843-47.792968 59.644531-47.792968 16.878906 0 32.148438 6.84375 43.203125 17.898437 8.066406 8.054687 13.890625 18.363281 16.441406 29.894531zm0 0",
    fill: "url(#P)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m169.300781 168.566406c-.238281.246094-.484375.484375-.730469.722656-14.363281 14.21875-33.855468 23.257813-55.449218 24.125l-10.785156-10.808593-.164063-.132813c-1.902344-1.570312-2.894531-3.980468-2.667969-6.441406l3.753906-39.027344c.070313-.679687.359376-1.289062.792969-1.777344-.039062-.050781-.070312-.105468-.113281-.164062-.609375-.394531-1.125-.953125-1.4375-1.644531l-4.320312-9.578125c-.300782-.652344-.332032-1.34375-.15625-1.964844.546874-.101562 1.097656-.207031 1.652343-.289062.394531-.074219.796875-.132813 1.191407-.1875.308593-.050782.628906-.089844.953124-.132813.359376-.042969.722657-.09375 1.09375-.125.445313-.050781.890626-.09375 1.335938-.132813.433594-.042968.878906-.074218 1.324219-.105468.453125-.03125.90625-.050782 1.363281-.070313.898438-.042969 1.808594-.0625 2.71875-.0625 1.664062 0 3.320312.0625 4.953125.195313.4375.042968.871094.074218 1.292969.125.878906.082031 1.757812.195312 2.628906.320312.421875.0625.855469.132813 1.28125.207032.496094.070312.992188.164062 1.476562.269531 12.214844 2.347656 23.125 8.332031 31.570313 16.78125 8.066406 8.058593 13.890625 18.367187 16.441406 29.898437zm0 0",
    fill: "url(#Q)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m117.144531 182.476562-4.253906 3.519532c-1.875 1.550781-4.589844 1.550781-6.464844 0l-4.253906-3.519532c-1.902344-1.570312-2.898437-3.984374-2.664063-6.441406l3.753907-39.027344c.15625-1.628906 1.523437-2.871093 3.160156-2.871093h6.472656c1.636719 0 3.003907 1.242187 3.160157 2.871093l3.753906 39.027344c.234375 2.457032-.761719 4.871094-2.664063 6.441406zm0 0",
    fill: "url(#S)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m116.054688 137.007812c-.15625-1.628906-1.523438-2.871093-3.160157-2.871093h-6.472656c-.964844 0-1.828125.441406-2.414063 1.128906l13.144532 13.140625zm0 0",
    fill: "url(#T)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m121.136719 123.84375-4.324219 9.574219c-.628906 1.394531-2.015625 2.285156-3.554688 2.285156h-7.199218c-1.539063 0-2.925782-.890625-3.554688-2.285156l-4.324218-9.574219c-.300782-.652344-.332032-1.34375-.15625-1.964844 3.765624-.726562 7.652343-1.105468 11.632812-1.105468s7.871094.378906 11.632812 1.113281c.179688.621093.136719 1.304687-.152343 1.957031zm0 0",
    fill: "url(#U)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m367.453125 144.054688-54.390625-16.378907c-37.21875-11.210937-76.910156-11.210937-114.125 0l-54.390625 16.378907c-8.199219 2.46875-14.792969 8.597656-17.851563 16.59375l-26.015624 67.933593c-19.265626 50.308594-3.269532 107.296875 39.355468 140.234375l71.125 54.957032c26.410156 20.40625 63.269532 20.40625 89.679688 0l71.125-54.957032c42.625-32.9375 58.621094-89.925781 39.355468-140.234375l-26.015624-67.933593c-3.058594-7.996094-9.65625-14.125-17.851563-16.59375zm0 0",
    fill: "url(#V)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m300.839844 423.773438 71.125-54.957032c42.625-32.9375 58.621094-89.925781 39.355468-140.234375l-26.015624-67.933593c-3.058594-7.996094-9.652344-14.125-17.851563-16.59375l-54.390625-16.378907c-18.605469-5.605469-37.835938-8.40625-57.0625-8.40625v319.808594c15.816406 0 31.632812-5.101563 44.839844-15.304687zm0 0",
    fill: "url(#W)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m351.640625 163.222656-46.671875-14.054687c-31.9375-9.617188-66-9.617188-97.9375 0l-46.671875 14.054687c-7.035156 2.121094-12.695313 7.378906-15.320313 14.242188l-22.324218 58.296875c-16.53125 43.167969-2.808594 92.074219 33.773437 120.339843l61.03125 47.15625c22.664063 17.511719 54.292969 17.511719 76.957031 0l61.035157-47.15625c36.578125-28.265624 50.304687-77.171874 33.773437-120.339843l-22.324218-58.296875c-2.625-6.863282-8.285157-12.121094-15.320313-14.242188zm0 0",
    fill: "url(#X)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m374.289062 277.472656c0-3.296875-.140624-6.5625-.40625-9.792968l-45.554687-45.558594c-4.828125-4.824219-12.652344-4.824219-17.476563 0l-66.125 66.125c-4.824218 4.824218-12.648437 4.824218-17.476562 0l-26.097656-26.101563c-4.828125-4.824219-12.652344-4.824219-17.476563 0l-11.59375 11.597657c-4.828125 4.824218-4.828125 12.648437 0 17.472656l103.003907 103.007812c56.253906-9.125 99.203124-57.917968 99.203124-116.75zm0 0",
    fill: "url(#Z)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m225.210938 344.347656c5.953124 5.953125 15.605468 5.953125 21.558593 0l93.152344-93.152344c4.824219-4.828124 4.824219-12.652343 0-17.476562l-11.59375-11.597656c-4.828125-4.824219-12.652344-4.824219-17.476563 0l-66.125 66.125c-4.824218 4.824218-12.648437 4.824218-17.476562 0l-26.097656-26.101563c-4.828125-4.824219-12.652344-4.824219-17.476563 0l-11.59375 11.597657c-4.828125 4.824218-4.828125 12.648437 0 17.472656zm0 0",
    fill: "url(#aa)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m294.476562 403.257812 61.035157-47.15625c36.578125-28.265624 50.304687-77.171874 33.773437-120.339843l-22.324218-58.296875c-2.628907-6.863282-8.285157-12.121094-15.320313-14.242188l-46.675781-14.054687c-15.96875-4.808594-32.464844-7.214844-48.964844-7.214844v274.4375c13.574219 0 27.148438-4.375 38.476562-13.132813zm0 0",
    fill: "url(#ab)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m338.609375 179.023438-40.3125-12.140626c-27.585937-8.308593-57.007813-8.308593-84.59375 0l-40.3125 12.140626c-6.078125 1.828124-10.964844 6.371093-13.234375 12.296874l-19.28125 50.355469c-14.28125 37.289063-2.425781 79.53125 29.171875 103.941407l52.714844 40.734374c19.578125 15.125 46.898437 15.125 66.472656 0l52.71875-40.734374c31.59375-24.414063 43.449219-66.652344 29.171875-103.941407l-19.28125-50.355469c-2.269531-5.925781-7.15625-10.46875-13.234375-12.296874zm0 0",
    fill: "url(#ac)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon-security.2facbccd458d1c12bc66b9fd202e30b2.svg";
export { ForwardRef as ReactComponent };